import * as React from 'react';
import {connect} from 'react-redux';
import {LockState, Operation, UserSession} from '../domain';
import {
    checkForUnauthorizedSensitiveAttributesOnFeature,
    checkUrlForSensitiveAttributes,
    emptySensitiveAttributeTypes,
    importVegkartFeatures,
    selectFeatureType, setCreateObjectVisible, ToggleAdditionalFeatureType,
    toggleAdditionalFeatureType,
    toggleAllFeatureTypeLocks
} from "../../../actions/actions";
import IssueSummaryBubble from "./IssueSummaryBubble";
import FeaturesState from "../domain/FeaturesState";
import VegkartImportModal from "./VegkartImportModal";
import {Button, OverlayTrigger, Popover} from 'react-bootstrap';
import {FeatureTypeSummary} from "../../../../integration/representation/feature-type";
import datacatalog, {AttributeType} from "../../../../integration/datacatalog/datacatalog-services";
import CommentSummaryIcon from "./CommentSummaryIcon";

interface FeatureTypesStateProps {
    user: UserSession;
    contractId: string;
    selectedFeatureType: number;
    additionalSelectedFeatureTypeIds: number[];
    featureTypes: FeatureTypeSummary[];
    datacatalog: datacatalog;
}

interface FeatureTypesDispatchProps {
    onSelectFeatureType: () => void;
    onSelectAdditionalFeatureType: ToggleAdditionalFeatureType;
    toggleAllFeatureTypeLocks: (lockState: LockState) => void;
    checkIfSensitiveAttributesOnFeature: (url: string) => AttributeType[];
    checkIfSensitiveAttributesOnFeatureForOtherUsers: (url: string, operation: Operation, callback?: (sensitive: boolean) => void) => boolean;
    emptySensitiveAttributeTypes: () => void;
    importVegkartFeatures: (url: string, operation: string) => void;
    createObject: () => void;
}

type FeatureTypesProps = FeatureTypesStateProps & FeatureTypesDispatchProps;

interface FeatureTypesState {
    searchFilter: string,
    submittedFilter: string
}

class FeatureTypes extends React.Component<FeatureTypesProps, FeatureTypesState> {

    constructor(props: FeatureTypesProps) {
        super(props);
        this.state = {
            searchFilter: '',
            submittedFilter: "NONE"
        }
    }

    searchFilterChanged(event: React.ChangeEvent<HTMLInputElement>) {
        let value: string = event.target.value;
        this.setState({searchFilter: value});
    }

    submitFilterChanged(filterState: string) {
        this.setState({submittedFilter: filterState});
    }

    render() {

        return <div className="feature-list grid-300">
            <FeatureTypesButtons
                user={this.props.user}
                contractId={this.props.contractId}
                toggleAllFeatureTypeLocks={this.props.toggleAllFeatureTypeLocks}
                onSubmitFilterChanged={(newVal) => this.submitFilterChanged(newVal)}
                submittedFilter={this.state.submittedFilter}
                checkIfSensitiveAttributesOnFeatureForCurrentUser={this.props.checkIfSensitiveAttributesOnFeature}
                checkIfSensitiveAttributesOnFeatureForOtherUsers={this.props.checkIfSensitiveAttributesOnFeatureForOtherUsers}
                emptySensitiveAttributeTypes={this.props.emptySensitiveAttributeTypes}
                importVegkartFeatures={this.props.importVegkartFeatures}
                datacatalog={this.props.datacatalog}
                createObject={this.props.createObject}
            />
            <FilterFeatureTypes onSearchFilterChanged={(e: React.ChangeEvent<HTMLInputElement>) => this.searchFilterChanged(e)}/>
            <FeatureTypesList
                searchFilter={this.state.searchFilter}
                submittedFilter={this.state.submittedFilter}
                onSelectFeatureType={this.props.onSelectFeatureType}
                onSelectAdditionalFeatureType={this.props.onSelectAdditionalFeatureType}
                featureTypes={this.props.featureTypes}
                selectedFeatureType={this.props.selectedFeatureType}
                additionalSelectedFeatureTypeIds={this.props.additionalSelectedFeatureTypeIds}/>
        </div>;
    }
}

interface FilterFeatureTypesProps {
    onSearchFilterChanged: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

class FilterFeatureTypes extends React.Component<FilterFeatureTypesProps, {}> {
    render() {
        return <div className="search input-group pull-left">
            <input type="text" className="form-control"
                   onChange={(e) => this.props.onSearchFilterChanged(e)}
                   placeholder="Søk" aria-label="Søk"/>
            <span className="input-group-addon"></span>
        </div>;
    }
}

interface LockFeatureTypesProps {
    user: UserSession,
    contractId: string,
    toggleAllFeatureTypeLocks: (state: LockState) => void,
    onSubmitFilterChanged: (submitFilter: string) => void,
    submittedFilter: string,
    importVegkartFeatures: (url: string, operation: string) => void,
    datacatalog: datacatalog,
    createObject: () => void;
}

interface OtherProps {
    checkIfSensitiveAttributesOnFeatureForCurrentUser: (url: string) => AttributeType[];
    checkIfSensitiveAttributesOnFeatureForOtherUsers: (url: string, operation: Operation) => boolean;
    emptySensitiveAttributeTypes: () => void;
}

type Props = LockFeatureTypesProps & OtherProps;

class FeatureTypesButtons extends React.Component<Props, {}> {

    render() {
        const canLock = this.props.user && this.props.user.hasPermission('FEATURE_TYPE_LOCK:TOGGLE', this.props.contractId);
        const canImport = this.props.user && this.props.user.hasPermission('FEATURE:IMPORT', this.props.contractId);
        const sensitiveTypes = this.props.user && this.props.user.sensitiveTypes;
        const submittedFilterText = this.props.submittedFilter;
        const buttonText = submittedFilterText == "NONE" ? "Skjul vegobjekttyper registrert i NVDB" : "Vis alle vegobjekttyper";
        const nextState = submittedFilterText == "NONE" ? "EXCLUDE-SUBMITTED" : "NONE";

        return (
            <div>
                <div className="feature-type-buttons-container second-row">
                    <Button onClick={this.props.createObject}>Opprett objekt</Button>
                </div>
                <div className="feature-type-buttons-container first-row">
                    <Button disabled={!canLock} onClick={() => this.props.toggleAllFeatureTypeLocks(LockState.LOCKED)}>Lås alle</Button>
                    <Button disabled={!canLock} onClick={() => this.props.toggleAllFeatureTypeLocks(LockState.OPEN)}>Lås opp alle</Button>
                    <VegkartImportModal
                        canImport={canImport}
                        checkIfSensitiveAttributesOnFeatureForCurrentUser={this.props.checkIfSensitiveAttributesOnFeatureForCurrentUser}
                        checkIfSensitiveAttributesOnFeatureForAllUsers={this.props.checkIfSensitiveAttributesOnFeatureForOtherUsers}
                        emptySensitiveAttributeTypes={this.props.emptySensitiveAttributeTypes}
                        importVegkartObjects={this.props.importVegkartFeatures}
                        userSensitiveTypes={sensitiveTypes}
                        datacatalog={this.props.datacatalog}
                    />
                </div>
                <div className="feature-type-buttons-container second-row">
                    <Button onClick={() => this.props.onSubmitFilterChanged(nextState)}>{buttonText}</Button>
                </div>
            </div>
        );
    }
}

interface FeatureTypesListProps {
    featureTypes: FeatureTypeSummary[];
    selectedFeatureType: number;
    additionalSelectedFeatureTypeIds: number[];
    onSelectFeatureType: (type: number) => void;
    onSelectAdditionalFeatureType: ToggleAdditionalFeatureType;
    searchFilter: string;
    submittedFilter: string
}

class FeatureTypesList extends React.Component<FeatureTypesListProps, {}> {

    onFeatureTypeClick(event: React.MouseEvent<HTMLLIElement>, featureTypeId: number) {
        if (event.ctrlKey && !!this.props.selectedFeatureType && featureTypeId != this.props.selectedFeatureType) {
            this.props.onSelectAdditionalFeatureType(featureTypeId)
        } else {
            this.props.onSelectFeatureType(featureTypeId)
        }
    }

    getRowCssClass(featureType: FeatureTypeSummary): string {
        const submitted = (featureType.isExporting);
        const selected = (featureType.typeid === this.props.selectedFeatureType);
        const additionalSelected = (this.props.additionalSelectedFeatureTypeIds.indexOf(featureType.typeid) != -1);

        if (submitted) {
            if (selected) {
                return 'submitted selected';
            } else if (additionalSelected) {
                return 'additional-selected submitted';
            }
            return 'submitted';
        }
        if (selected) {
            return 'selected';
        }
        if (additionalSelected) {
            return 'additional-selected'
        }
        return '';
    }
    render() {
        const {featureTypes, searchFilter, submittedFilter} = this.props;
        return <ul id={"featurelist"}>
            {featureTypes
                .filter(featureType => featureType.name.toLowerCase().indexOf(searchFilter.toLowerCase()) != -1)
                .filter(featureType => submittedFilter == "NONE" || (!featureType.isExporting && featureType.isDirty))
                .map((featureType: FeatureTypeSummary, i: number) => {
                        return (featureType.isExporting || !featureType.isDirty) ? this.getSubmittedFeatureTypeContent(featureType, i) : this.getFeatureTypeContent(featureType, i)
                    }
                )}
        </ul>;
    }

    getFeatureTypeContent(featureType: FeatureTypeSummary, i: number) {
        return <li key={i} className={this.getRowCssClass(featureType)}
                   onClick={(e: React.MouseEvent<HTMLLIElement>) => this.onFeatureTypeClick(e, featureType.typeid)}>
            <div className="text-bold text-black">
                <span className="color-mid-gray">{featureType.typeid}</span>&nbsp;
                {featureType.name}
                <LockIcon isLocked={featureType.isLocked}/>
                <span className="float-right numbubble issuebubble">{featureType.numFeatures}</span>
                <CommentSummaryIcon classes={'feature'} numComments={featureType.numFeatureComments} />
                <CommentSummaryIcon classes={'feature-type'} numComments={featureType.numFeatureTypeComments} />
            </div>
            <div/>
            <div className="status-icon file-attributes">
                <IssueSummaryBubble severity="error" numIssues={featureType.aggregatedErrors.numError}/>
                <IssueSummaryBubble severity="warning" numIssues={featureType.aggregatedErrors.numWarning}/>
                <IssueSummaryBubble severity="notabene"
                                    numIssues={featureType.aggregatedErrors.numNotabene}/>
                <IssueSummaryBubble severity="ok"
                                    numIssues={featureType.aggregatedErrors.numError + featureType.aggregatedErrors.numWarning + featureType.aggregatedErrors.numNotabene}/>
            </div>
        </li>
    }

    getSubmittedFeatureTypeContent(featureType: FeatureTypeSummary, i: number) {
        let nvdbStatusPopover: React.ReactNode;
        let nvdbStatusIcon: string;
        if (featureType.isExporting) {
            nvdbStatusPopover = (<Popover id={"NvdbStatus" + i}>
                Alle vegobjekter i typen er under eksport til NVDB
            </Popover>);
            nvdbStatusIcon = "glyphicon-save";
        } else {
            nvdbStatusPopover = (<Popover id={"NvdbStatus" + i}>
                Alle vegobjekter i typen er synkronisert med NVDB
            </Popover>);
            nvdbStatusIcon = "glyphicon-saved";
        }

        return <li key={i} className={this.getRowCssClass(featureType)}
                   onClick={(e: React.MouseEvent<HTMLLIElement>) => this.onFeatureTypeClick(e, featureType.typeid)}>
            <div key={featureType.sortNum} className="text-bold text-black">
                <span className="color-mid-gray">{featureType.typeid}</span>&nbsp;
                {featureType.name}
                <span className="float-right numbubble issuebubble">{featureType.numFeatures}</span>
                <OverlayTrigger trigger={['hover']} placement="right" overlay={nvdbStatusPopover}>
                    <span className={'glyphicon ' + nvdbStatusIcon + ' float-right submitted-to-nvdb-icon'} />
                </OverlayTrigger>
                <CommentSummaryIcon classes={'feature'} numComments={featureType.numFeatureComments} />
                <CommentSummaryIcon classes={'feature-type'} numComments={featureType.numFeatureTypeComments} />
            </div>
        </li>
    }
}

interface LockIconProps {
    isLocked: boolean
}

class LockIcon extends React.Component<LockIconProps, {}> {
    render() {
        return this.props.isLocked && <span className="fas fa-lock lock" title="Objekttypen er låst"/>;
    }
}

const mapFeatureListStateToProps = (state: FeaturesState): FeatureTypesStateProps => {
    let selectedFeatureType = state.selectedFeatureTypeId;
    return {
        user: state.user,
        contractId: state.contractId,
        featureTypes: state.featureTypes,
        selectedFeatureType: selectedFeatureType ? selectedFeatureType : null,
        additionalSelectedFeatureTypeIds: state.additionalSelectedFeatureTypes.map(ft => ft.typeId),
        datacatalog: state.datacatalog
    };
};

const mapDispatchToProps = ({
    onSelectFeatureType: selectFeatureType,
    onSelectAdditionalFeatureType: toggleAdditionalFeatureType,
    toggleAllFeatureTypeLocks,
    checkIfSensitiveAttributesOnFeature: checkForUnauthorizedSensitiveAttributesOnFeature,
    checkIfSensitiveAttributesOnFeatureForOtherUsers: checkUrlForSensitiveAttributes,
    emptySensitiveAttributeTypes,
    importVegkartFeatures,
    createObject: () => setCreateObjectVisible(true)
});
export default connect(mapFeatureListStateToProps, mapDispatchToProps)(FeatureTypes);
